document.addEventListener("DOMContentLoaded", () => {
  
  // Find all option fieldsets…
  document.querySelectorAll("fieldset.product-form__input").forEach(fs => {
    // …but skip the tea-variety one
    if (fs.classList.contains("tea-variety-selector")) return;
    if (fs.classList.contains("milk-variety-selector")) return;
    if (fs.classList.contains("fusion-variety-selector")) return;

    const legend = fs.querySelector("legend.form__label")?.textContent.trim() || "";
    const wrapper = document.createElement("div");
    wrapper.className = "custom-select-wrapper";

    const select = document.createElement("select");
    select.className = "custom-select";
    select.setAttribute("aria-label", legend);

    fs.querySelectorAll('input[type="radio"]').forEach(radio => {
      const lbl    = fs.querySelector(`label[for="${radio.id}"]`);
      const option = document.createElement("option");
      option.value       = radio.id;
      option.textContent = lbl ? lbl.textContent.trim() : radio.value;
      if (radio.checked)  option.selected = true;
      if (radio.disabled) option.disabled = true;
      select.appendChild(option);
    });

    wrapper.appendChild(select);
    const legendEl = fs.querySelector("legend.form__label");
    legendEl && legendEl.parentNode.insertBefore(wrapper, legendEl.nextSibling);

    select.addEventListener("change", () => {
      const chosenId    = select.value;
      const targetRadio = fs.querySelector(`#${CSS.escape(chosenId)}`);
      if (targetRadio) targetRadio.checked = true;
    });
  });

    var carousel = document.querySelector('.product-carousel-wrapper .carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.carousel__slide');
    var thumbs = document.querySelectorAll('.carousel__thumbnails .carousel__thumb');
    var prevBtn = carousel.querySelector('.carousel__nav--prev');
    var nextBtn = carousel.querySelector('.carousel__nav--next');
    var currentIndex = 0;

    function showSlide(index) {
      slides[currentIndex].classList.remove('is-active');
      thumbs[currentIndex].classList.remove('is-active');
      currentIndex = index;
      slides[currentIndex].classList.add('is-active');
      thumbs[currentIndex].classList.add('is-active');
    }

    prevBtn.addEventListener('click', function() {
      var newIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
      showSlide(newIndex);
    });

    nextBtn.addEventListener('click', function() {
      var newIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
      showSlide(newIndex);
    });

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-index'));
        showSlide(idx);
      });
    });
  });
